import styled from 'styled-components'

export const FlowMain = styled.div`
  > * + * {
    margin-top: ${({ spaceScale }) => `${spaceScale}rem`};
  }
`
